export default "__VITE_ASSET__BvToh19a__"